import React from 'react';
import Keyboard from '../../keyboard/Keyboard';

export default class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: '' };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getPlaceholderLang = this.getPlaceholderLang.bind(this);
  }

  componentDidMount() {
    this.key = new Keyboard(this.handleChange);
    this.key.createKeyboardWrapper();
    this.keyboard = document.querySelector('.keyboard');
    document.querySelector('.search').focus();
    this.getPlaceholderLang();
  }

  getPlaceholderLang() {
    const { language } = this.props.data;
    switch (language) {
      case 'en':
        return 'Search city';
      case 'ru':
        return 'Найти город';
      case 'be':
        return 'Знайсці горад';
      default:
        break;
    }
  }

  formSubmitHandler = (e) => {
    e.preventDefault();
  };

  handleChange(event) {
    this.setState({ value: event });
  }

  handleSubmit(event) {
    this.event.preventDefault();
  }

  hideKeyboard() {
    if (this.keyboard.classList.contains('keyboard_hide')) {
      return this.keyboard.classList.remove('keyboard_hide');
    }
    return this.keyboard.classList.add('keyboard_hide');
  }

  render() {
    return (
      <form onSubmit={(this.handleChange, this.formSubmitHandler)}>
        <input
          type="text"
          className="search"
          placeholder={this.getPlaceholderLang()}
          value={this.state.value}
          onChange={this.handleChange}
          onKeyDown={(e) => {
            if (e.key === 'Enter') this.props.data.func(this.state.value);
          }}
        />
        <img
          src="https://acegif.com/wp-content/uploads/loading-25.gif"
          className="search__load search__load_hide"
          id="loading"
          alt="loading"
        />
        <button
          className="search__keyboard"
          type="button"
          onClick={() => {
            this.hideKeyboard();
          }}
        />
        <button
          type="button"
          className="search-btn"
          onClick={() => {
            this.props.data.func(this.state.value);
          }}
          data-i18n="search.searchBtn"
        >
          Search
        </button>
      </form>
    );
  }
}
